import { render, staticRenderFns } from "./CustSelector.vue?vue&type=template&id=67373106&"
import script from "./CustSelector.vue?vue&type=script&lang=js&"
export * from "./CustSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports